/* eslint-disable import/extensions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable react/jsx-one-expression-per-line */

import React, { useState, useEffect, useRef } from 'react';
import firebase from 'firebase/app';
import * as Sentry from '@sentry/react';
import { Link } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { FaFacebookSquare } from 'react-icons/fa';

import Checkbox from '@material-ui/core/Checkbox';

import PATH from 'routes/path';
import fb from 'firebaseConfig';

import { getEula } from 'services/api/eula';
import { firebaseErrors } from 'services/api/firebaseErrors';

import GoogleIcon from 'assets/icons/SvgIcons/Google.js';

import Menu from 'components/Menu';
import { Input } from 'components/Input';
import { Button } from 'components/Button';
import { Title, Text } from 'components/Text';
import { ALERT_TYPE } from 'components/Alert';
import { SimpleInputMask } from 'components/InputMask';
import SnackMessage, { OPTIONS } from 'components/SnackMessage';

import EulaModal from './EulaModal';
import CodeModal from './CodeModal';
import EmailModal from './EmailModal';
import MissingCodeModal from './MissingCodeModal';

import {
  Wrapper, CheckBoxWrapper, Divider, Container,
} from './styles';

// Página de cadastro
const SignUp = () => {
  const [user, setUser] = useState({
    name: '',
    phone: '',
    email: '',
  });
  const [signMethod, setSignMethod] = useState(
    localStorage.getItem('webview') ? 'phone' : 'email',
  );
  const [checked, setChecked] = useState(false);
  const [checkedNotifications, setCheckedNotifications] = useState(false);
  const [loading, setLoading] = useState(false);
  const [complete, setComplete] = useState(false);
  const [loadingConfirm, setLoadingConfirm] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openEula, setOpenEula] = useState(false);
  const [openEmailModal, setEmailModal] = useState(false);
  const [openMissingModal, setMissingModal] = useState(false);
  const [eula, setEula] = useState({});
  const [isPrivacy, setIsPrivacy] = useState(false);
  const mktInputRef = useRef(null);

  const url = new URL(window.location.href);

  // Provedor de Autenticação (Google)
  const googleProvider = new firebase.auth.GoogleAuthProvider();

  // Provedor de Autenticação (Facebook)
  const facebookProvider = new firebase.auth.FacebookAuthProvider();

  const { enqueueSnackbar } = useSnackbar();

  // Config. para login por link de email
  const actionCodeSettings = {
    handleCodeInApp: true,
    url: `${process.env.REACT_APP_APP_URL}/login`,
    // android: {
    //   packageName: 'com.loitfgts',
    // },
    // dynamicLinkDomain: 'loitfgts.page.link',
  };

  // Carrega termos de uso
  const loadEula = async () => {
    try {
      const { data } = await getEula();
      setEula(data[0]);
    } catch (error) {
      enqueueSnackbar(
        'Erro ao carregar os Termos de Uso e a Política de Privacidade.',
        {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              message={message}
              variant={ALERT_TYPE.ERROR}
            />
          ),
        },
      );
    }
  };

  useEffect(() => {
    document.title = 'LOIT FGTS - Revisão monetária do seu FGTS';

    loadEula();

    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
      'recaptcha-container',
      { size: 'invisible' },
    );
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setUser({
      ...user,
      [name]: value,
    });
  };

  const toggleChecked = (e) => {
    setChecked(e.target.checked);
  };

  // Reseta container do reCAPTCHA
  const resetRecaptcha = () => window.recaptchaVerifier.reset();

  const showEula = () => setOpenEula(true);

  const closeEula = () => setOpenEula(false);

  const showModal = () => {
    if (openMissingModal) setMissingModal(false);
    setOpenModal(true);
  };

  const closeModal = () => {
    setLoading(false);
    setOpenModal(false);
    resetRecaptcha();
  };

  const showMissingModal = () => {
    if (openModal) setOpenModal(false);
    setMissingModal(true);
  };

  const closeMissingModal = () => {
    setLoading(false);
    setMissingModal(false);
    resetRecaptcha();
  };

  const showEmailModal = () => {
    setOpenModal(false);
    setEmailModal(true);
  };

  const closeEmailModal = () => {
    setLoading(false);
    setEmailModal(false);
  };

  // Enviar link por email
  const handleSignWithEmail = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      await fb.auth().sendSignInLinkToEmail(user.email, actionCodeSettings);

      setComplete(true);
      showEmailModal();

      localStorage.events = JSON.stringify(['31 - envio email']);

      document.cookie = `mkt_cookies=${mktInputRef.current?.value}; path=loitfgts.com.br`;
      localStorage.idEula = eula.id;
      localStorage.setItem('nameForSignIn', user.name);
      localStorage.setItem('emailForSignIn', user.email);
      localStorage.setItem('mkt_cookies', mktInputRef.current.value);
      localStorage.setItem('event', 'register/customer');
    } catch (error) {
      if (error.code) {
        enqueueSnackbar(firebaseErrors[error.code], {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              message={message}
              variant={ALERT_TYPE.ERROR}
            />
          ),
        });
        Sentry.captureException(new Error('Failed to send link by email'));
      }
    } finally {
      setLoading(false);
    }
  };

  // Cadastro com a conta do Google
  const signWithGoogle = async () => {
    if (checked && checkedNotifications) {
      try {
        await fb.auth().signInWithPopup(googleProvider);
        /** @type {firebase.auth.OAuthCredential} */
        // const credential = result.credential;
        // const token = credential.accessToken;

        localStorage.session = 'true';
        localStorage.idEula = eula.id;
        document.cookie = `mkt_cookies=${mktInputRef.current?.value}; path=loitfgts.com.br`;

        localStorage.events = JSON.stringify([
          '11 - cadastro google',
          '21 - acesso google',
          '50 - primeiro acesso',
        ]);

        const payload = {
          utm_source: url.searchParams.get('utm_source'),
          utm_medium: url.searchParams.get('utm_medium'),
          utm_campaign: url.searchParams.get('utm_campaign'),
        };
        window.Intercom('trackEvent', 'LOIT FGTS cadastro', payload);
        // const user = result.user;
        localStorage.setItem('mkt_cookies', mktInputRef.current.value);
        localStorage.setItem('event', 'register/customer');
      } catch (error) {
        if (error.code) {
          enqueueSnackbar(firebaseErrors[error.code], {
            ...OPTIONS,
            content: (key, message) => (
              <SnackMessage
                id={key}
                message={message}
                variant={ALERT_TYPE.ERROR}
              />
            ),
          });
          Sentry.captureException(new Error('failed to register with Google account'));
        }
      }
    } else if (checkedNotifications) {
      enqueueSnackbar(
        'Para prosseguir é necessário estar de acordo com a Política de Privacidade.',
        {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              message={message}
              variant={ALERT_TYPE.ERROR}
            />
          ),
        },
      );
    } else if (checked) {
      enqueueSnackbar(
        'Para prosseguir é necessário aceitar o envio de notificações.',
        {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              message={message}
              variant={ALERT_TYPE.ERROR}
            />
          ),
        },
      );
    } else {
      enqueueSnackbar(
        'Para prosseguir é necessário estar de acordo com a Política de Privacidade e com as notificações.',
        {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              message={message}
              variant={ALERT_TYPE.ERROR}
            />
          ),
        },
      );
    }
  };

  // Exibe recaptcha e envia o código de verificação
  const handleSignUpWithPhone = async (e) => {
    e.preventDefault();

    setLoading(true);

    const { phone } = user;
    const appVerifier = window.recaptchaVerifier;

    try {
      const result = await fb.auth().signInWithPhoneNumber(phone, appVerifier);
      window.confirmationResult = result;

      // Exibe modal para inserir o código de verificação
      showModal();
      localStorage.setItem('mkt_cookies', mktInputRef.current.value);
      localStorage.setItem('event', 'register/customer');
      document.cookie = `mkt_cookies=${mktInputRef.current?.value}; path=loitfgts.com.br`;
    } catch (error) {
      setLoading(false);
      resetRecaptcha();
      if (error.code) {
        enqueueSnackbar(firebaseErrors[error.code], {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              message={message}
              variant={ALERT_TYPE.ERROR}
            />
          ),
        });
      }
    }
  };

  // Completa o cadastro após confirmação do código de verificação
  const completeVerification = async (code) => {
    const { name } = user;

    setLoadingConfirm(true);

    try {
      await window.confirmationResult.confirm(code);

      await fb.auth().currentUser.updateProfile({
        displayName: name,
      });

      localStorage.session = 'true';
      localStorage.idEula = eula.id;
      localStorage.events = JSON.stringify([
        '10 - cadastro',
        '20 - acesso',
        '30 - sms',
        '40 - código de acesso',
        '50 - primeiro acesso',
      ]);
      const payload = {
        utm_source: url.searchParams.get('utm_source'),
        utm_medium: url.searchParams.get('utm_medium'),
        utm_campaign: url.searchParams.get('utm_campaign'),
      };
      window.Intercom('trackEvent', 'LOIT FGTS cadastro', payload);
    } catch (error) {
      if (error.code) {
        enqueueSnackbar(firebaseErrors[error.code], {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              message={message}
              variant={ALERT_TYPE.ERROR}
            />
          ),
        });
        Sentry.captureException(new Error('failed to register'));
      }
      resetRecaptcha();
    } finally {
      setLoading(false);
      setLoadingConfirm(false);
    }
  };

  // Reenvio do código de confirmação
  const retryVerification = async () => {
    closeMissingModal();

    setLoading(true);

    const { phone } = user;
    const appVerifier = window.recaptchaVerifier;

    try {
      const result = await fb.auth().signInWithPhoneNumber(phone, appVerifier);
      window.confirmationResult = result;

      // Exibe modal para inserir o código de verificação
      showModal();
      localStorage.setItem('mkt_cookies', mktInputRef.current.value);
      localStorage.setItem('event', 'register/customer');
    } catch (error) {
      setLoading(false);
      if (error.code) {
        enqueueSnackbar(firebaseErrors[error.code], {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              message={message}
              variant={ALERT_TYPE.ERROR}
            />
          ),
        });
      }
      resetRecaptcha();
    }
  };

  // Login com a conta do Facebook
  const handleSignWithFacebook = async () => {
    if (checked && checkedNotifications) {
      try {
        await fb.auth().signInWithPopup(facebookProvider);
        /** @type {firebase.auth.OAuthCredential} */

        localStorage.session = 'true';
        localStorage.events = JSON.stringify([
          '21 - acesso facebook',
          '50 - primeiro acesso',
        ]);
        localStorage.setItem('mkt_cookies', mktInputRef.current.value);
        localStorage.setItem('event', 'register/customer');
        document.cookie = `mkt_cookies=${mktInputRef.current?.value}; path=loitfgts.com.br`;
      } catch (error) {
        Sentry.captureException(new Error('failed to login with Facebook'));
        if (error.code) {
          enqueueSnackbar(firebaseErrors[error.code], {
            ...OPTIONS,
            content: (key, message) => (
              <SnackMessage
                id={key}
                message={message}
                variant={ALERT_TYPE.ERROR}
              />
            ),
          });
        }
      }
    } else if (checkedNotifications) {
      enqueueSnackbar(
        'Para prosseguir é necessário estar de acordo com a Política de Privacidade.',
        {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              message={message}
              variant={ALERT_TYPE.ERROR}
            />
          ),
        },
      );
    } else if (checked) {
      enqueueSnackbar(
        'Para prosseguir é necessário aceitar o envio de notificações.',
        {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              message={message}
              variant={ALERT_TYPE.ERROR}
            />
          ),
        },
      );
    } else {
      enqueueSnackbar(
        'Para prosseguir é necessário estar de acordo com a Política de Privacidade e com as notificações.',
        {
          ...OPTIONS,
          content: (key, message) => (
            <SnackMessage
              id={key}
              message={message}
              variant={ALERT_TYPE.ERROR}
            />
          ),
        },
      );
    }
  };

  return (
    <>
      {/* MENU */}
      <Menu />
      {/* CONTEÚDO */}
      <Wrapper>
        {/* TERMOS DE USO */}
        <EulaModal
          data={eula}
          open={openEula}
          onClose={closeEula}
          isPrivacy={isPrivacy}
        />
        {/* MODAL DE CÓDIGO DE CONFIRMAÇÃO */}
        <CodeModal
          phone={user.phone}
          open={openModal}
          onClose={closeModal}
          loading={loadingConfirm}
          showEmailModal={showEmailModal}
          showModal={showMissingModal}
          complete={completeVerification}
        />
        {/* MODAL DE CÓDIGO NÃO RECEBIDO */}
        <MissingCodeModal
          phone={user.phone}
          open={openMissingModal}
          retry={retryVerification}
          onClose={closeMissingModal}
        />
        {/* MODAL DE LOGIN POR LINK DE EMAIL */}
        <EmailModal
          email={user.email}
          handleChange={handleChange}
          handleSubmit={handleSignWithEmail}
          open={openEmailModal}
          complete={complete}
          onClose={closeEmailModal}
          setSignMethod={setSignMethod}
        />
        <Container>
          <Title>Bem vindo(a)!</Title>
          <Text>Insira seus dados abaixo para cadastrar</Text>
          {/* FORMULÁRIO DE CADASTRO */}
          <form
            onSubmit={
              signMethod === 'email'
                ? handleSignWithEmail
                : handleSignUpWithPhone
            }
          >
            {/* Nome completo */}
            <Input
              icon
              required
              autoFocus
              name="name"
              type="text"
              placeholder="Nome"
              value={user.name}
              onChange={handleChange}
              title="Insira o seu nome"
            />
            <input
              type="hidden"
              name="mkt_cookies"
              className="mkt_cookies"
              ref={mktInputRef}
            />
            {/* E-mail */}
            {signMethod === 'email' && (
              <Input
                icon
                required
                name="email"
                type="email"
                value={user.email}
                onChange={handleChange}
                placeholder="E-mail"
                title="Insira o seu E-mail"
              />
            )}
            {/* Número de celular (com máscara) */}
            {signMethod === 'phone' && (
              <SimpleInputMask
                icon
                required
                name="phone"
                type="tel"
                mask="+55 (99) 9 9999-9999"
                placeholder="Número do celular"
                value={user.phone}
                onChange={handleChange}
                title="Insira o seu número de celular"
              />
            )}
            {/* Termos de Uso */}
            <CheckBoxWrapper>
              <Checkbox
                size="small"
                color="secondary"
                checked={checked}
                onChange={toggleChecked}
                inputProps={{ 'aria-label': 'primary checkbox' }}
              />
              <Text comment style={{ fontSize: 16 }}>
                Ao continuar você declara ter lido e estar de acordo com nossos{' '}
                <a
                  onClick={() => {
                    showEula();
                    setIsPrivacy(false);
                  }}
                >
                  Termos de Uso
                </a>{' '}
                e{' '}
                <a
                  target="_blank"
                  href="https://ajuda.tikal.tech/pt-BR/articles/5320633-declaracao-de-politica-de-privacidade-e-protecao-de-dados"
                  rel="noreferrer"
                >
                  Política de Privacidade
                </a>
                .
              </Text>
            </CheckBoxWrapper>
            <CheckBoxWrapper>
              <Checkbox
                size="small"
                color="secondary"
                checked={checkedNotifications}
                onChange={(e) => setCheckedNotifications(e.target.checked)}
                inputProps={{ 'aria-label': 'primary checkbox' }}
              />
              <Text comment style={{ fontSize: 16 }}>
                Autorizo o envio de mensagens e notificações da LOIT
              </Text>
            </CheckBoxWrapper>
            <Button type="submit" loading={loading} disabled={!checked || !checkedNotifications}>
              Cadastrar
            </Button>
            <Link to={PATH.LOGIN}>
              <Button variant="outlined" className="unset">
                Já tenho cadastro
              </Button>
            </Link>
            {!localStorage.getItem('webview') && (
              <>
                <Divider>ou</Divider>
                <Button
                  variant="outlined"
                  onClick={signWithGoogle}
                  startIcon={<GoogleIcon />}
                  style={{ margin: '15px 0' }}
                >
                  Cadastre-se com o Google
                </Button>
                <Button
                  variant="outlined"
                  startIcon={<FaFacebookSquare color="#4267B2" />}
                  onClick={handleSignWithFacebook}
                >
                  Cadastre-se com o Facebook
                </Button>
              </>
            )}
            {/* Reaptcha container */}
            <div id="recaptcha-container" />
          </form>
        </Container>
      </Wrapper>
    </>
  );
};

export default SignUp;
